import React from "react";
import { ActionIcon, MantineSize } from "@mantine/core";
import { IconX } from "@tabler/icons";

export interface AddressRightSectionProps {
  shouldClear?: boolean;
  onClear?: () => void;
  error?: any;
  // eslint-disable-next-line react/no-unused-prop-types
  disabled?: boolean;
}

export const AddressRightSection = ({
  shouldClear,
  onClear,
  error,
}: AddressRightSectionProps) => {
  return shouldClear ? (
    <ActionIcon
      onClick={onClear}
      onMouseDown={(event) => event.preventDefault()}
    >
      <IconX size={14} />
    </ActionIcon>
  ) : null;
};
